import React from "react";
import PropTypes from "prop-types";

import { format } from "date-fns";
import moment from "moment";
import { Icon } from "semantic-ui-react";

import "scenes/Hubly/Hubly.css";

import PureExistingTaskReminder from "./PureExistingTaskReminder";
import PureNewTaskReminder from "./PureNewTaskReminder";

const PureTaskReminder = ({
  taskTitle,
  reminder,
  hasReminder,
  overdueInfo,
  setSelectedDate,
  selectedDate,
  saveReminder,
  addingTask,
  openReminderRescheduleModal,
  dismissReminder,
  hasSequentialReminder,
}) => {
  const taskTitleAlt = taskTitle.length > 0 ? taskTitle : "emptyTask";

  const dateFormat = (r, defaultValue) => {
    if (!r?.time) return defaultValue;
    return format(moment(r.time).toDate(), "PPPPp");
  };

  if (hasReminder && !addingTask) {
    return (
      <PureExistingTaskReminder
        title={dateFormat(reminder, "Reminder")}
        taskTitle={taskTitleAlt}
        overdueInfo={overdueInfo}
        dismissReminder={dismissReminder}
        openReminderRescheduleModal={openReminderRescheduleModal}
      />
    );
  }

  if (hasSequentialReminder) {
    return (
      <Icon.Group title="This task has a sequential reminder saved">
        <Icon link color="grey" name="bell" />
        <Icon
          link
          corner
          name="clock"
          style={{ color: "#aaaaaa", textShadow: "none" }}
        />
      </Icon.Group>
    );
  }

  return (
    <PureNewTaskReminder
      title={dateFormat(reminder, "a New Reminder")}
      taskTitle={taskTitleAlt}
      overdueInfo={overdueInfo}
      hasReminder={hasReminder}
      selectedDate={selectedDate}
      setSelectedDate={setSelectedDate}
      saveReminder={saveReminder}
    />
  );
};

PureTaskReminder.propTypes = {
  taskTitle: PropTypes.string,
  reminder: PropTypes.object,
  hasReminder: PropTypes.bool.isRequired,
  hasSequentialReminder: PropTypes.bool,
  overdueInfo: PropTypes.object,
  setSelectedDate: PropTypes.func.isRequired,
  selectedDate: PropTypes.object.isRequired,
  saveReminder: PropTypes.func.isRequired,
  addingTask: PropTypes.bool,
  openReminderRescheduleModal: PropTypes.func.isRequired,
  dismissReminder: PropTypes.func.isRequired,
};

PureTaskReminder.defaultProps = {
  taskTitle: "",
  reminder: undefined,
  overdueInfo: {},
  addingTask: false,
  hasSequentialReminder: false,
};

export default PureTaskReminder;
